import styled from '@emotion/styled';
import css from '@styled-system/css';
import type * as CSS from 'csstype';
import { system, typography } from 'styled-system';

import { shouldForwardProp } from '../internal/styles/utils';
import { TextColorProps } from '../themes/cobalt/types';
import { ResponsiveValue } from '../themes/types';

export interface BaseTextProps extends TextColorProps {
  ellipsis?: boolean;
  textAlign?: ResponsiveValue<CSS.Property.TextAlign>;
  textDecoration?: ResponsiveValue<CSS.Property.TextDecoration<'none'>>;
  textTransform?: ResponsiveValue<CSS.Property.TextTransform>;
  fontStyle?: ResponsiveValue<CSS.Property.FontStyle>;
  textOverflow?: ResponsiveValue<CSS.Property.TextOverflow>;
  whiteSpace?: ResponsiveValue<CSS.Property.WhiteSpace>;
}

const BaseText = styled('div', {
  shouldForwardProp,
})<BaseTextProps>(
  typography,
  system({
    textOverflow: true,
    textTransform: true,
    textDecoration: true,
    whiteSpace: true,
    color: {
      property: 'color',
      scale: 'colors',
    },
  }),
  ({ ellipsis }) =>
    ellipsis &&
    css({
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
  css({
    fontFamily: 'body',
  })
);

export default BaseText;
